export const GET_PROJECT_COMMENTS_ATTEMPT = 'GET_PROJECT_COMMENTS_ATTEMPT';
export type GET_PROJECT_COMMENTS_ATTEMPT = typeof GET_PROJECT_COMMENTS_ATTEMPT;

export const GET_PROJECT_COMMENTS_SUCCESS = 'GET_PROJECT_COMMENTS_SUCCESS';
export type GET_PROJECT_COMMENTS_SUCCESS = typeof GET_PROJECT_COMMENTS_SUCCESS;

export const GET_PROJECT_COMMENTS_FAILURE = 'GET_PROJECT_COMMENTS_FAILURE';
export type GET_PROJECT_COMMENTS_FAILURE = typeof GET_PROJECT_COMMENTS_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/comments/get/Types.tsx